// extracted by mini-css-extract-plugin
export default {"menuToggle":"XuAusd","toggleOpen":"JE2AzB","buttonContainer":"qWnGwM","hamburger":"XQyHuG"};